
/**
 * Sets up the mobile navigation functionality
 */ function $9616fb7cd8a8c9e6$export$7b7f71765f51ec79() {
    const mobileNavToggle = document.querySelector('.mobile-nav-toggle');
    const nav = document.querySelector('.nav');
    if (!mobileNavToggle || !nav) return;
    // Check if we're on mobile based on media query
    // NOTE: 768px must match the $mobile breakpoint in _variables.scss
    const isMobile = ()=>window.matchMedia('(max-width: 768px)').matches;
    // Function to update navigation visibility based on screen size
    const updateNavVisibility = ()=>{
        if (isMobile()) // On mobile: hide by default, unless it has the 'show' class
        {
            if (!nav.classList.contains('show')) nav.style.display = 'none';
        } else {
            // On desktop: always visible, reset styles
            nav.style.display = '';
            nav.classList.remove('show');
        }
    };
    // Initial setup
    updateNavVisibility();
    // Update on window resize
    window.addEventListener('resize', updateNavVisibility);
    // Toggle navigation when button is clicked
    mobileNavToggle.addEventListener('click', ()=>{
        if (nav.classList.contains('show')) {
            nav.classList.remove('show');
            mobileNavToggle.setAttribute('aria-expanded', 'false');
            // Add a small delay before hiding to allow for transition
            setTimeout(()=>{
                if (isMobile()) nav.style.display = 'none';
            }, 300);
        } else {
            nav.style.display = 'flex';
            // Small delay to ensure display is applied before adding class
            setTimeout(()=>{
                nav.classList.add('show');
                mobileNavToggle.setAttribute('aria-expanded', 'true');
            }, 10);
        }
    });
    // Close navigation when a link is clicked
    const navLinks = nav.querySelectorAll('a');
    navLinks.forEach((link)=>{
        link.addEventListener('click', ()=>{
            if (isMobile()) {
                nav.classList.remove('show');
                mobileNavToggle.setAttribute('aria-expanded', 'false');
                setTimeout(()=>{
                    nav.style.display = 'none';
                }, 300);
            }
        });
    });
    // Close navigation when clicking outside
    document.addEventListener('click', (event)=>{
        if (!nav.contains(event.target) && !mobileNavToggle.contains(event.target) && nav.classList.contains('show') && isMobile()) {
            nav.classList.remove('show');
            mobileNavToggle.setAttribute('aria-expanded', 'false');
            setTimeout(()=>{
                nav.style.display = 'none';
            }, 300);
        }
    });
}


const $673ff3dfc4a496de$var$isString = (obj)=>typeof obj === 'string';
const $673ff3dfc4a496de$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $673ff3dfc4a496de$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $673ff3dfc4a496de$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $673ff3dfc4a496de$var$lastOfPathSeparatorRegExp = /###/g;
const $673ff3dfc4a496de$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($673ff3dfc4a496de$var$lastOfPathSeparatorRegExp, '.') : key;
const $673ff3dfc4a496de$var$canNotTraverseDeeper = (object)=>!object || $673ff3dfc4a496de$var$isString(object);
const $673ff3dfc4a496de$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$673ff3dfc4a496de$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
        const key = $673ff3dfc4a496de$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($673ff3dfc4a496de$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $673ff3dfc4a496de$var$cleanKey(stack[stackIndex])
    };
};
const $673ff3dfc4a496de$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
        if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $673ff3dfc4a496de$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $673ff3dfc4a496de$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
};
const $673ff3dfc4a496de$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
};
const $673ff3dfc4a496de$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($673ff3dfc4a496de$var$isString(target[prop]) || target[prop] instanceof String || $673ff3dfc4a496de$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $673ff3dfc4a496de$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $673ff3dfc4a496de$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $673ff3dfc4a496de$var$escape = (data)=>{
    if ($673ff3dfc4a496de$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$673ff3dfc4a496de$var$_entityMap[s]);
    return data;
};
class $673ff3dfc4a496de$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $673ff3dfc4a496de$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache = new $673ff3dfc4a496de$var$RegExpCache(20);
const $673ff3dfc4a496de$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $673ff3dfc4a496de$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $673ff3dfc4a496de$var$deepFind = function(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $673ff3dfc4a496de$var$getCleanedCode = (code)=>code && code.replace('_', '-');
const $673ff3dfc4a496de$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $673ff3dfc4a496de$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, 'log', '', true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, 'warn', '', true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, 'error', '');
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($673ff3dfc4a496de$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $673ff3dfc4a496de$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $673ff3dfc4a496de$var$Logger(this.logger, options);
    }
}
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
class $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
class $673ff3dfc4a496de$var$ResourceStore extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($673ff3dfc4a496de$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $673ff3dfc4a496de$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$673ff3dfc4a496de$var$isString(key)) return result;
        return $673ff3dfc4a496de$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $673ff3dfc4a496de$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if ($673ff3dfc4a496de$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $673ff3dfc4a496de$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === 'v1') return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $673ff3dfc4a496de$var$checkedLoadedFor = {};
class $673ff3dfc4a496de$var$Translator extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $673ff3dfc4a496de$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $673ff3dfc4a496de$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = !$673ff3dfc4a496de$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !($673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(res))) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(res);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $673ff3dfc4a496de$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && !$673ff3dfc4a496de$var$isString(options.count);
            const hasDefaultValue = $673ff3dfc4a496de$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : '';
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== 'v1') res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = $673ff3dfc4a496de$var$isString(res) && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && !$673ff3dfc4a496de$var$isString(options.replace) ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = $673ff3dfc4a496de$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($673ff3dfc4a496de$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && !$673ff3dfc4a496de$var$isString(options.count);
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && ($673ff3dfc4a496de$var$isString(options.context) || typeof options.context === 'number') && options.context !== '';
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$673ff3dfc4a496de$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
const $673ff3dfc4a496de$var$capitalize = (string)=>string.charAt(0).toUpperCase() + string.slice(1);
class $673ff3dfc4a496de$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($673ff3dfc4a496de$var$isString(code) && code.indexOf('-') > -1) {
            if (typeof Intl !== 'undefined' && typeof Intl.getCanonicalLocales !== 'undefined') try {
                let formattedCode = Intl.getCanonicalLocales(code)[0];
                if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
                if (formattedCode) return formattedCode;
            } catch (e) {}
            const specialCases = [
                'hans',
                'hant',
                'latn',
                'cyrl',
                'cans',
                'mong',
                'arab'
            ];
            let p = code.split('-');
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $673ff3dfc4a496de$var$capitalize(p[2].toLowerCase());
            }
            return p.join('-');
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($673ff3dfc4a496de$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($673ff3dfc4a496de$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($673ff3dfc4a496de$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $673ff3dfc4a496de$var$sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $673ff3dfc4a496de$var$_rulesPluralsTypes = {
    1: (n)=>Number(n > 1),
    2: (n)=>Number(n != 1),
    3: (n)=>0,
    4: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    5: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5),
    6: (n)=>Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2),
    7: (n)=>Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    8: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3),
    9: (n)=>Number(n >= 2),
    10: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4),
    11: (n)=>Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3),
    12: (n)=>Number(n % 10 != 1 || n % 100 == 11),
    13: (n)=>Number(n !== 0),
    14: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3),
    15: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
    16: (n)=>Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2),
    17: (n)=>Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1),
    18: (n)=>Number(n == 0 ? 0 : n == 1 ? 1 : 2),
    19: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3),
    20: (n)=>Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2),
    21: (n)=>Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0),
    22: (n)=>Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3)
};
const $673ff3dfc4a496de$var$nonIntlVersions = [
    'v1',
    'v2',
    'v3'
];
const $673ff3dfc4a496de$var$intlVersions = [
    'v4'
];
const $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $673ff3dfc4a496de$var$createRules = ()=>{
    const rules = {};
    $673ff3dfc4a496de$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $673ff3dfc4a496de$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
};
class $673ff3dfc4a496de$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('pluralResolver');
        if ((!this.options.compatibilityJSON || $673ff3dfc4a496de$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
            this.options.compatibilityJSON = 'v3';
            this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
        }
        this.rules = $673ff3dfc4a496de$var$createRules();
        this.pluralRulesCache = {};
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) {
            const cleanedCode = $673ff3dfc4a496de$var$getCleanedCode(code === 'dev' ? 'en' : code);
            const type = options.ordinal ? 'ordinal' : 'cardinal';
            const cacheKey = JSON.stringify({
                cleanedCode: cleanedCode,
                type: type
            });
            if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
            let rule;
            try {
                rule = new Intl.PluralRules(cleanedCode, {
                    type: type
                });
            } catch (err) {
                if (!code.match(/-|_/)) return;
                const lngPart = this.languageUtils.getLanguagePartFromCode(code);
                rule = this.getRule(lngPart, options);
            }
            this.pluralRulesCache[cacheKey] = rule;
            return rule;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return '';
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = 'plural';
            else if (suffix === 1) suffix = '';
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === 'v1') {
            if (suffix === 1) return '';
            if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$673ff3dfc4a496de$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
const $673ff3dfc4a496de$var$deepFindWithDefaults = function(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $673ff3dfc4a496de$var$isString(key)) {
        path = $673ff3dfc4a496de$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $673ff3dfc4a496de$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $673ff3dfc4a496de$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $673ff3dfc4a496de$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $673ff3dfc4a496de$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $673ff3dfc4a496de$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $673ff3dfc4a496de$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp && existingRegExp.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$673ff3dfc4a496de$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $673ff3dfc4a496de$var$regexSafe(this.escape(val)) : $673ff3dfc4a496de$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $673ff3dfc4a496de$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$673ff3dfc4a496de$var$isString(value) && !this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && !$673ff3dfc4a496de$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$673ff3dfc4a496de$var$isString(value)) return value;
            if (!$673ff3dfc4a496de$var$isString(value)) value = $673ff3dfc4a496de$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
const $673ff3dfc4a496de$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $673ff3dfc4a496de$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (val, lng, options)=>{
        let optForCache = options;
        if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) optForCache = {
            ...optForCache,
            [options.interpolationkey]: undefined
        };
        const key = lng + JSON.stringify(optForCache);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($673ff3dfc4a496de$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
};
class $673ff3dfc4a496de$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        this.formatSeparator = options.interpolation.formatSeparator || ',';
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $673ff3dfc4a496de$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
const $673ff3dfc4a496de$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $673ff3dfc4a496de$var$Connector extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $673ff3dfc4a496de$var$pushPath(q.loaded, [
                lng
            ], ns);
            $673ff3dfc4a496de$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($673ff3dfc4a496de$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($673ff3dfc4a496de$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
const $673ff3dfc4a496de$var$get = ()=>({
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($673ff3dfc4a496de$var$isString(args[1])) ret.defaultValue = args[1];
            if ($673ff3dfc4a496de$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    });
const $673ff3dfc4a496de$var$transformOptions = (options)=>{
    if ($673ff3dfc4a496de$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($673ff3dfc4a496de$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($673ff3dfc4a496de$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
};
const $673ff3dfc4a496de$var$noop = ()=>{};
const $673ff3dfc4a496de$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $673ff3dfc4a496de$var$I18n extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $673ff3dfc4a496de$var$transformOptions(options);
        this.services = {};
        this.logger = $673ff3dfc4a496de$var$baseLogger;
        this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if ($673ff3dfc4a496de$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $673ff3dfc4a496de$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$673ff3dfc4a496de$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== 'v1') this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== 'undefined') formatter = $673ff3dfc4a496de$var$Formatter;
            const lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
            this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $673ff3dfc4a496de$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
            this.translator.on('*', function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $673ff3dfc4a496de$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== 'v1' && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
        let usedCallback = callback;
        const usedLng = $673ff3dfc4a496de$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $673ff3dfc4a496de$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit('languageChanged', l);
                this.logger.log('languageChanged', l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = $673ff3dfc4a496de$var$isString(lngs) ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== 'object') {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            if (options.keyPrefix !== '') options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || '.';
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if ($673ff3dfc4a496de$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($673ff3dfc4a496de$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if ($673ff3dfc4a496de$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services && this.services.languageUtils || new $673ff3dfc4a496de$var$LanguageUtil($673ff3dfc4a496de$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $673ff3dfc4a496de$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $673ff3dfc4a496de$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $673ff3dfc4a496de$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$I18n.createInstance();
$673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
const $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance;
const $673ff3dfc4a496de$export$147ec2801e896265 = $673ff3dfc4a496de$export$2e2bcd8739ae039.dir;
const $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$export$2e2bcd8739ae039.init;
const $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadResources;
const $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$export$2e2bcd8739ae039.reloadResources;
const $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$export$2e2bcd8739ae039.use;
const $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$export$2e2bcd8739ae039.changeLanguage;
const $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$export$2e2bcd8739ae039.getFixedT;
const $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$export$2e2bcd8739ae039.t;
const $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$export$2e2bcd8739ae039.exists;
const $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$export$2e2bcd8739ae039.setDefaultNamespace;
const $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$export$2e2bcd8739ae039.hasLoadedNamespace;
const $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadNamespaces;
const $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadLanguages;


const $8ffa09d0fc6e8fd5$export$b4204e90fe207393 = {
    // Header
    "logo": "Gabriela Nowakowska",
    "nav": {
        "about": "About",
        "experience": "Experience",
        "publications": "Publications",
        "teaching": "Teaching",
        "contact": "Contact"
    },
    // Hero
    "hero": {
        "badge": "Assistant Professor",
        "titlePrefix": "",
        "titleName": "Gabriela Nowakowska,",
        "titleSuffix": "PhD",
        "subtitle": "Adam Mickiewicz University",
        "description": "I have a PhD in computer science and love combining theory with practical applications. Right now, I'm working with Allegro through Laniqo, focusing on machine translation for e-commerce \u2013 basically making global shopping easier and more accessible. Before that, I worked at Snowflake (ex-Applica) on document understanding, turning unstructured data into something useful. My research has been featured at international conferences, and what excites me most is solving real-world problems with NLP, ML, and AI.",
        "contactBtn": "Contact Me",
        "publicationsBtn": "View Publications"
    },
    // Experience
    "experience": {
        "title": "Education & Experience",
        "workTitle": "Work Experience",
        "educationTitle": "Education",
        "present": "Present",
        "labels": {
            "supervisor": "Supervisor:",
            "defenseDate": "Defense date:",
            "showAbstract": "Show Abstract",
            "hideAbstract": "Hide Abstract"
        },
        "work1": {
            "title": "Senior Machine Learning Developer",
            "company": "Laniqo",
            "description": "Research and development in Product Intelligence for e-commerce, focusing on product knowledge, confidence, and search relevance. Responsibilities include developing Allegro's AI Shopping Assistant to drive conversational discovery, as well as previously building e-commerce machine translation solutions through model training, evaluation, and prompt engineering."
        },
        "work1Allegro": {
            "title": "Senior MT Research Scientist",
            "company": "Allegro",
            "description": "Research and development in Product Intelligence for e-commerce, focusing on product knowledge, confidence, and search relevance. Responsibilities include developing Allegro's AI Shopping Assistant to drive conversational discovery, as well as previously building e-commerce machine translation solutions through model training, evaluation, and prompt engineering."
        },
        "work2": {
            "title": "Research Scientist",
            "company": "Snowflake (ex-Applica)",
            "description": "Research and development in information extraction from business documents. Developed models to extract data into lists and tables from long documents, and built a dataset management system to streamline data preparation and organization."
        },
        "work3": {
            "title": "Deep Learning Specialist",
            "company": "Applica",
            "description": "Research and development in information extraction from business documents. Developed models for extracting data from structured (e.g., lists, tables), unstructured (raw text), and graphical elements (e.g., signatures, stamps, checkboxes), prepared training, testing, and validation datasets, and conducted experiments to evaluate and optimize model performance."
        },
        "edu1": {
            "title": "PhD in Computer Science",
            "institution": "Adam Mickiewicz University",
            "titleEn": "Named entity recognition and information extraction from various documents",
            "titlePl": "Rozpoznawanie jednostek nazwanych i ekstrakcja informacji z dokument\xf3w r\xf3\u017Cnego typu",
            "supervisor": "prof. UAM dr hab. Tomasz G\xf3recki",
            "defenseDate": "January 14, 2025"
        },
        "edu2": {
            "title": "Master's in Computer Science",
            "institution": "Adam Mickiewicz University",
            "titleEn": "Query expansion using language models",
            "titlePl": "Rozszerzanie zapyta\u0144 przy u\u017Cyciu modeli j\u0119zyka",
            "supervisor": "prof. UAM dr hab. Filip Grali\u0144ski",
            "defenseDate": "June 30, 2020"
        },
        "edu3": {
            "title": "Bachelor's in Computer Science",
            "institution": "Adam Mickiewicz University",
            "titleEn": "Conference Management System - application for simplifying the process of creating and managing conferences",
            "titlePl": "System Obs\u0142ugi Konferencji - Aplikacja wspomagaj\u0105ca tworzenie i uczestniczenie w konferencjach",
            "supervisor": "prof. UAM dr hab. Krzysztof Dyczkowski",
            "defenseDate": "February 13, 2019"
        },
        "eduMathMaster": {
            "title": "Master's in Mathematics",
            "institution": "Adam Mickiewicz University",
            "titleEn": "Computability concept formalizations",
            "titlePl": "Formalizacje poj\u0119cia obliczalno\u015Bci",
            "supervisor": "prof. UAM dr hab. Izabela Bondecka-Krzykowska",
            "defenseDate": "July 9, 2019"
        },
        "eduMathBachelor": {
            "title": "Bachelor's in Mathematics",
            "institution": "Adam Mickiewicz University",
            "titleEn": "\u0141ukasiewicz logic as an example of many valued logic",
            "titlePl": "Logika \u0141ukasiewicza jako przyk\u0142ad logiki wielowarto\u015Bciowej",
            "supervisor": "prof. UAM dr hab. Izabela Bondecka-Krzykowska",
            "defenseDate": "July 3, 2017"
        }
    },
    // Publications
    "publications": {
        "title": "Publications",
        "labels": {
            "authors": "Authors:",
            "venue": "Venue:",
            "doi": "DOI:",
            "url": "URL:",
            "date": "Date:",
            "showAbstract": "Show Abstract",
            "hideAbstract": "Hide Abstract"
        }
    },
    // Teaching
    "teaching": {
        "title": "Teaching",
        "course1": {
            "title": "Formal Languages and Computational Complexity",
            "polish": "J\u0119zyki formalne i z\u0142o\u017Cono\u015B\u0107 obliczeniowa",
            "linkLabel": "J\u0119zyki formalne i z\u0142o\u017Cono\u015B\u0107 obliczeniowa (lab.) (2026/SL) (G. Nowakowska)",
            "description": "Lab sessions (computer lab) focus on practical applications of finite automata in programming \u2014 implementing regular expressions, designing parsers, and representing automata in code structures. Students learn to apply formal computational models to real-world programming tasks."
        },
        "course2": {
            "title": "Machine Learning",
            "polish": "Uczenie maszynowe",
            "linkLabelNew": "Uczenie maszynowe (lab.) (2026/SZ) (G. Nowakowska)",
            "linkLabel": "Uczenie maszynowe (lab.) (2025/SZ) (D. Filipiak, D. Ewald, G. Nowakowska)",
            "description": "Lab sessions focus on practical implementation of machine learning algorithms in Python using NumPy, PyTorch, and Scikit-Learn. Students implement linear and logistic regression, evaluation and cross-validation methods, unsupervised learning algorithms, and neural networks. The course concludes with an individual programming project."
        }
    },
    // Contact
    "contact": {
        "title": "Contact",
        "email": "Email: gabriela.nowakowska@amu.edu.pl",
        "emailLabel": "Email",
        "consultationTitle": "Student Consultation Hours",
        "consultation1": "\u2022 Tuesdays: 12:00-13:00 (in person) - please send a message beforehand, otherwise I might be in a different part of the building",
        "consultation2": '\u2022 The second time slot is flexible - please send an email and we\'ll schedule a consultation (online consultation via Microsoft Teams <i class="fas fa-video" style="color: #6264A7;"></i> also available)',
        "orcid": "ORCID: 0000-0002-5139-2126"
    },
    // Page title
    "pageTitle": "Gabriela Nowakowska | Assistant Professor",
    "pageTitleExperience": "Experience | Gabriela Nowakowska",
    "pageTitlePublications": "Publications | Gabriela Nowakowska",
    // Footer
    "footer": {
        "copyright": "Gabriela Nowakowska. All rights reserved.",
        "university": "Adam Mickiewicz University"
    }
};


const $7e77b3ca3dc9e5e5$export$c5fdf4f179b274c9 = {
    // Header
    "logo": "Gabriela Nowakowska",
    "nav": {
        "about": "O mnie",
        "experience": "Do\u015Bwiadczenie",
        "publications": "Publikacje",
        "teaching": "Dydaktyka",
        "contact": "Kontakt"
    },
    // Hero
    "hero": {
        "badge": "Adiunkt",
        "titlePrefix": "Dr in\u017C.",
        "titleName": "Gabriela Nowakowska",
        "titleSuffix": "",
        "subtitle": "Uniwersytet im. Adama Mickiewicza w Poznaniu",
        "description": "Posiadam doktorat z informatyki i uwielbiam \u0142\u0105czy\u0107 teori\u0119 z praktycznymi zastosowaniami. Obecnie pracuj\u0119 z Allegro poprzez Laniqo, skupiaj\u0105c si\u0119 na t\u0142umaczeniu maszynowym dla e-commerce \u2013 zasadniczo u\u0142atwiaj\u0105c i zwi\u0119kszaj\u0105c dost\u0119pno\u015B\u0107 globalnych zakup\xf3w. Wcze\u015Bniej pracowa\u0142am w Snowflake (dawniej Applica) nad rozumieniem dokument\xf3w, przekszta\u0142caj\u0105c nieustrukturyzowane dane w co\u015B u\u017Cytecznego. Moje badania by\u0142y prezentowane na mi\u0119dzynarodowych konferencjach, a najbardziej ekscytuje mnie rozwi\u0105zywanie rzeczywistych problem\xf3w z wykorzystaniem NLP, ML i AI.",
        "contactBtn": "Skontaktuj si\u0119",
        "publicationsBtn": "Zobacz publikacje"
    },
    // Experience
    "experience": {
        "title": "Wykszta\u0142cenie i Do\u015Bwiadczenie",
        "workTitle": "Do\u015Bwiadczenie Zawodowe",
        "educationTitle": "Wykszta\u0142cenie",
        "present": "Teraz",
        "labels": {
            "supervisor": "Promotor:",
            "defenseDate": "Data obrony:",
            "showAbstract": "Poka\u017C streszczenie",
            "hideAbstract": "Ukryj streszczenie"
        },
        "work1": {
            "title": "Senior Machine Learning Developer",
            "company": "Laniqo",
            "description": "Badania i rozw\xf3j w obszarze Product Intelligence dla e-commerce, ze szczeg\xf3lnym uwzgl\u0119dnieniem wiedzy o produktach, pewno\u015Bci predykcji oraz trafno\u015Bci wyszukiwania. Zakres obowi\u0105zk\xf3w obejmuje rozw\xf3j Asystenta Zakupowego AI Allegro, wspieraj\u0105cego konwersacyjne odkrywanie produkt\xf3w, a wcze\u015Bniej tak\u017Ce tworzenie rozwi\u0105za\u0144 t\u0142umaczenia maszynowego dla e-commerce poprzez trenowanie i ewaluacj\u0119 modeli oraz prompt engineering."
        },
        "work1Allegro": {
            "title": "Senior MT Research Scientist",
            "company": "Allegro",
            "description": "Badania i rozw\xf3j w obszarze Product Intelligence dla e-commerce, ze szczeg\xf3lnym uwzgl\u0119dnieniem wiedzy o produktach, pewno\u015Bci predykcji oraz trafno\u015Bci wyszukiwania. Zakres obowi\u0105zk\xf3w obejmuje rozw\xf3j Asystenta Zakupowego AI Allegro, wspieraj\u0105cego konwersacyjne odkrywanie produkt\xf3w, a wcze\u015Bniej tak\u017Ce tworzenie rozwi\u0105za\u0144 t\u0142umaczenia maszynowego dla e-commerce poprzez trenowanie i ewaluacj\u0119 modeli oraz prompt engineering."
        },
        "work2": {
            "title": "Research Scientist",
            "company": "Snowflake (dawniej Applica)",
            "description": "Badania i rozw\xf3j w zakresie ekstrakcji informacji z dokument\xf3w biznesowych. Tworzenie modeli wyodr\u0119bniaj\u0105cych dane w listy i tabele z d\u0142ugich dokument\xf3w oraz budowa systemu zarz\u0105dzania zbiorami danych usprawniaj\u0105cego przygotowanie i organizacj\u0119 danych."
        },
        "work3": {
            "title": "Deep Learning Specialist",
            "company": "Applica",
            "description": "Badania i rozw\xf3j w zakresie ekstrakcji informacji z dokument\xf3w biznesowych. Tworzenie modeli wyodr\u0119bniaj\u0105cych dane ze struktur (np. listy, tabele), tre\u015Bci nieustrukturyzowanych (tekst) i element\xf3w graficznych (np. podpisy, piecz\u0105tki, checkboxy), przygotowanie zbior\xf3w treningowych, testowych i walidacyjnych oraz prowadzenie eksperyment\xf3w oceniaj\u0105cych i optymalizuj\u0105cych wydajno\u015B\u0107 modeli."
        },
        "edu1": {
            "title": "Doktor Informatyki",
            "institution": "Uniwersytet im. Adama Mickiewicza w Poznaniu",
            "titleEn": "Named entity recognition and information extraction from various documents",
            "titlePl": "Rozpoznawanie jednostek nazwanych i ekstrakcja informacji z dokument\xf3w r\xf3\u017Cnego typu",
            "supervisor": "prof. UAM dr hab. Tomasz G\xf3recki",
            "defenseDate": "14 stycznia 2025"
        },
        "edu2": {
            "title": "Magister Informatyki",
            "institution": "Uniwersytet im. Adama Mickiewicza w Poznaniu",
            "titleEn": "Query expansion using language models",
            "titlePl": "Rozszerzanie zapyta\u0144 przy u\u017Cyciu modeli j\u0119zyka",
            "supervisor": "prof. UAM dr hab. Filip Grali\u0144ski",
            "defenseDate": "30 czerwca 2020"
        },
        "edu3": {
            "title": "In\u017Cynier Informatyki",
            "institution": "Uniwersytet im. Adama Mickiewicza w Poznaniu",
            "titleEn": "Conference Management System - application for simplifying the process of creating and managing conferences",
            "titlePl": "System Obs\u0142ugi Konferencji - Aplikacja wspomagaj\u0105ca tworzenie i uczestniczenie w konferencjach",
            "supervisor": "prof. UAM dr hab. Krzysztof Dyczkowski",
            "defenseDate": "13 lutego 2019"
        },
        "eduMathMaster": {
            "title": "Magister Matematyki",
            "institution": "Uniwersytet im. Adama Mickiewicza w Poznaniu",
            "titleEn": "Computability concept formalizations",
            "titlePl": "Formalizacje poj\u0119cia obliczalno\u015Bci",
            "supervisor": "prof. UAM dr hab. Izabela Bondecka-Krzykowska",
            "defenseDate": "9 lipca 2019"
        },
        "eduMathBachelor": {
            "title": "Licencjat Matematyki",
            "institution": "Uniwersytet im. Adama Mickiewicza w Poznaniu",
            "titleEn": "\u0141ukasiewicz logic as an example of many valued logic",
            "titlePl": "Logika \u0141ukasiewicza jako przyk\u0142ad logiki wielowarto\u015Bciowej",
            "supervisor": "prof. UAM dr hab. Izabela Bondecka-Krzykowska",
            "defenseDate": "3 lipca 2017"
        }
    },
    // Publications
    "publications": {
        "title": "Publikacje",
        "labels": {
            "authors": "Autorzy:",
            "venue": "Miejsce publikacji:",
            "doi": "DOI:",
            "url": "URL:",
            "date": "Data:",
            "showAbstract": "Poka\u017C streszczenie",
            "hideAbstract": "Ukryj streszczenie"
        }
    },
    // Teaching
    "teaching": {
        "title": "Dydaktyka",
        "course1": {
            "title": "Formal Languages and Computational Complexity",
            "polish": "J\u0119zyki formalne i z\u0142o\u017Cono\u015B\u0107 obliczeniowa",
            "linkLabel": "J\u0119zyki formalne i z\u0142o\u017Cono\u015B\u0107 obliczeniowa (lab.) (2026/SL) (G. Nowakowska)",
            "description": "\u0106wiczenia w salach komputerowych skupiaj\u0105 si\u0119 na praktycznych zastosowaniach automat\xf3w sko\u0144czonych w programowaniu \u2013 implementacji wyra\u017Ce\u0144 regularnych, projektowaniu parser\xf3w oraz reprezentacji automat\xf3w w strukturach kodu. Studenci ucz\u0105 si\u0119 stosowa\u0107 formalne modele obliczeniowe w rzeczywistych zadaniach programistycznych."
        },
        "course2": {
            "title": "Machine Learning",
            "polish": "Uczenie maszynowe",
            "linkLabelNew": "Uczenie maszynowe (lab.) (2026/SZ) (G. Nowakowska)",
            "linkLabel": "Uczenie maszynowe (lab.) (2025/SZ) (D. Filipiak, D. Ewald, G. Nowakowska)",
            "description": "Laboratorium koncentruje si\u0119 na praktycznej implementacji algorytm\xf3w uczenia maszynowego w Pythonie z u\u017Cyciem bibliotek NumPy, PyTorch i Scikit-Learn. Studenci implementuj\u0105 regresj\u0119 liniow\u0105 i logistyczn\u0105, metody ewaluacji i walidacji krzy\u017Cowej, algorytmy uczenia nienadzorowanego oraz sieci neuronowe. Zaj\u0119cia ko\u0144cz\u0105 si\u0119 indywidualnym projektem programistycznym."
        }
    },
    // Contact
    "contact": {
        "title": "Kontakt",
        "email": "Email: gabriela.nowakowska@amu.edu.pl",
        "emailLabel": "E-mail",
        "consultationTitle": "Konsultacje dla student\xf3w",
        "consultation1": "\u2022 Wtorki: 12:00-13:00 (stacjonarnie) - prosz\u0119 o wcze\u015Bniejsz\u0105 wiadomo\u015B\u0107, inaczej mog\u0119 znajdowa\u0107 si\u0119 w innej cz\u0119\u015Bci budynku",
        "consultation2": '\u2022 Drugi termin jest ruchomy - prosz\u0119 napisa\u0107 maila, a um\xf3wimy si\u0119 na konsultacj\u0119 (mo\u017Cliwa konsultacja online przez Microsoft Teams <i class="fas fa-video" style="color: #6264A7;"></i>)',
        "orcid": "ORCID: 0000-0002-5139-2126"
    },
    // Page title
    "pageTitle": "Gabriela Nowakowska | Adiunkt",
    "pageTitleExperience": "Do\u015Bwiadczenie | Gabriela Nowakowska",
    "pageTitlePublications": "Publikacje | Gabriela Nowakowska",
    // Footer
    "footer": {
        "copyright": "Gabriela Nowakowska. Wszelkie prawa zastrze\u017Cone.",
        "university": "Uniwersytet im. Adama Mickiewicza w Poznaniu"
    }
};


// Get saved language preference or detect from browser
const $9e30b5b5de697b16$var$savedLang = localStorage.getItem('lang');
const $9e30b5b5de697b16$var$browserLang = navigator.language || navigator.userLanguage;
const $9e30b5b5de697b16$var$defaultLang = $9e30b5b5de697b16$var$savedLang || ($9e30b5b5de697b16$var$browserLang.startsWith('en') ? 'en' : 'pl');
// Initialize i18next with translations
(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).init({
    resources: {
        en: {
            translation: (0, $8ffa09d0fc6e8fd5$export$b4204e90fe207393)
        },
        pl: {
            translation: (0, $7e77b3ca3dc9e5e5$export$c5fdf4f179b274c9)
        }
    },
    fallbackLng: 'pl',
    lng: $9e30b5b5de697b16$var$defaultLang,
    debug: false
});
/**
 * Update all DOM elements that have data-i18n attribute
 */ function $9e30b5b5de697b16$var$updateContent() {
    document.querySelectorAll('[data-i18n]').forEach((element)=>{
        const key = element.getAttribute('data-i18n');
        element.textContent = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t(key);
    });
    document.querySelectorAll('[data-i18n-html]').forEach((element)=>{
        const key = element.getAttribute('data-i18n-html');
        element.innerHTML = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t(key);
    });
    const page = document.documentElement.dataset.page;
    const titleKey = page === 'experience' ? 'pageTitleExperience' : page === 'publications' ? 'pageTitlePublications' : 'pageTitle';
    document.title = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t(titleKey);
}
function $9e30b5b5de697b16$export$56c6447e87399d89() {
    // Make sure the HTML lang attribute is set immediately
    document.documentElement.setAttribute('lang', (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).language);
    // Initial translation
    $9e30b5b5de697b16$var$updateContent();
    document.documentElement.style.visibility = '';
    // Set active language button
    $9e30b5b5de697b16$var$setActiveLanguageButton((0, $673ff3dfc4a496de$export$2e2bcd8739ae039).language);
    // Add event listeners to language buttons
    const langButtons = document.querySelectorAll('.lang-btn');
    langButtons.forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const lang = btn.getAttribute('data-lang');
            localStorage.setItem('lang', lang);
            (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).changeLanguage(lang, ()=>{
                $9e30b5b5de697b16$var$setActiveLanguageButton(lang);
            });
        });
    });
    // Language change event
    (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).on('languageChanged', ()=>{
        $9e30b5b5de697b16$var$updateContent();
        document.documentElement.setAttribute('lang', (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).language);
    });
}
/**
 * Set the active language button
 * @param {string} lang - Language code (en/pl)
 */ function $9e30b5b5de697b16$var$setActiveLanguageButton(lang) {
    const langButtons = document.querySelectorAll('.lang-btn');
    langButtons.forEach((btn)=>{
        if (btn.getAttribute('data-lang') === lang) btn.classList.add('active');
        else btn.classList.remove('active');
    });
    // Set the HTML lang attribute
    document.documentElement.setAttribute('lang', lang);
}



/**
 * Publications data
 */ const $8cdddf034d4a8d49$var$publications = [
    {
        title: "Arctic-TILT. Business Document Understanding at Sub-Billion Scale",
        authors: "\u0141 Borchmann, M Pietruszka, W Ja\u015Bkowski, D Jurkiewicz, P Halama, P J\xf3ziak, \u0141 Garncarek, P Liskowski, K Szyndler, A Gretkowski, J O\u0142tusek, G Nowakowska, A Zaw\u0142ocki, \u0141 Duhr, P Dyda, M Turski",
        citation: "Proceedings of the 63rd Annual Meeting of the Association for Computational Linguistics",
        year: "2025",
        citations: 0,
        link: "https://aclanthology.org/2025.acl-industry.20/",
        doi: "10.18653/v1/2025.acl-industry.20",
        dateISO: "2025-07-27",
        abstract: "The vast portion of workloads employing LLMs involves answering questions grounded on PDF or scan content. We introduce the Arctic-TILT achieving accuracy on par with models 1000\xd7 its size on these use cases. It can be fine-tuned and deployed on a single 24GB GPU, lowering operational costs while processing Visually Rich Documents with up to 400k tokens. The model establishes state-of-the-art results on seven diverse Document Understanding benchmarks, as well as provides reliable confidence scores and quick inference, which are essential for processing files in large-scale or time-sensitive enterprise environments."
    },
    {
        title: "STable: Table Generation Framework for Encoder-Decoder Models",
        authors: "M Pietruszka, M Turski, \u0141 Borchmann, T Dwojak, G Nowakowska, K Szyndler, D Jurkiewicz, \u0141 Garncarek",
        citation: "Proceedings of the 18th Conference of the European Chapter of the Association for Computational Linguistics",
        year: "2024",
        citations: 0,
        link: "https://aclanthology.org/2024.eacl-long.151/",
        doi: "10.18653/v1/2024.eacl-long.151",
        dateISO: "2024-03-18",
        abstract: "The output structure of database-like tables, consisting of values structured in horizontal rows and vertical columns identifiable by name, can cover a wide range of NLP tasks. Following this constatation, we propose a framework for text-to-table neural models applicable to problems such as extraction of line items, joint entity and relation extraction, or knowledge base population. The permutation-based decoder of our proposal is a generalized sequential method that comprehends information from all cells in the table. The training maximizes the expected log-likelihood for a table's content across all random permutations of the factorization order. During the content inference, we exploit the model's ability to generate cells in any order by searching over possible orderings to maximize the model's confidence and avoid substantial error accumulation, which other sequential models are prone to. Experiments demonstrate a high practical value of the framework, which establishes state-of-the-art results on several challenging datasets, outperforming previous solutions by up to 15%."
    },
    {
        title: "Exploring the Use of Foundation Models for Named Entity Recognition and Lemmatization Tasks in Slavic Languages",
        authors: "G Pa\u0142ka, A Nowakowski",
        citation: "Proceedings of the 9th Workshop on Slavic Natural Language Processing 2023 (SlavicNLP 2023)",
        year: "2023",
        citations: 0,
        link: "https://aclanthology.org/2023.bsnlp-1.19/",
        doi: "10.18653/v1/2023.bsnlp-1.19",
        dateISO: "2023-05-06",
        abstract: "This paper describes Adam Mickiewicz University's (AMU) solution for the 4th Shared Task on SlavNER. The task involves the identification, categorization, and lemmatization of named entities in Slavic languages. Our approach involved exploring the use of foundation models for these tasks. In particular, we used models based on the popular BERT and T5 model architectures. Additionally, we used external datasets to further improve the quality of our models. Our solution obtained promising results, achieving high metrics scores in both tasks. We describe our approach and the results of our experiments in detail, showing that the method is effective for NER and lemmatization in Slavic languages. Additionally, our models for lemmatization will be available at: https://huggingface.co/amu-cai."
    },
    {
        title: "Adam Mickiewicz University at WMT 2022: NER-Assisted and Quality-Aware Neural Machine Translation",
        authors: "A Nowakowski, G Pa\u0142ka, K Guttmann, M Pokrywka",
        citation: "Proceedings of the Seventh Conference on Machine Translation (WMT)",
        year: "2022",
        citations: 0,
        link: "https://aclanthology.org/2022.wmt-1.26/",
        dateISO: "2022-12-07",
        abstract: "This paper presents Adam Mickiewicz University's (AMU) submissions to the constrained track of the WMT 2022 General MT Task. We participated in the Ukrainian \u2194 Czech translation directions. The systems are a weighted ensemble of four models based on the Transformer (big) architecture. The models use source factors to utilize the information about named entities present in the input. Each of the models in the ensemble was trained using only the data provided by the shared task organizers. A noisy back-translation technique was used to augment the training corpora. One of the models in the ensemble is a document-level model, trained on parallel and synthetic longer sequences. During the sentence-level decoding process, the ensemble generated the n-best list. The n-best list was merged with the n-best list generated by a single document-level model which translated multiple sentences at a time. Finally, existing quality estimation models and minimum Bayes risk decoding were used to rerank the n-best list so that the best hypothesis was chosen according to the COMET evaluation metric. According to the automatic evaluation results, our systems rank first in both translation directions."
    },
    {
        title: "Going Full-TILT Boogie on Document Understanding with Text-Image-Layout Transformer",
        authors: "R Powalski, \u0141 Borchmann, D Jurkiewicz, T Dwojak, M Pietruszka, G Pa\u0142ka",
        citation: "Document Analysis and Recognition \u2013 ICDAR 2021",
        year: "2021",
        citations: 0,
        link: "https://link.springer.com/chapter/10.1007/978-3-030-86331-9_47",
        doi: "10.1007/978-3-030-86331-9_47",
        dateISO: "2021-09-02",
        abstract: "We address the challenging problem of Natural Language Comprehension beyond plain-text documents by introducing the TILT neural network architecture which simultaneously learns layout information, visual features, and textual semantics. Contrary to previous approaches, we rely on a decoder capable of unifying a variety of problems involving natural language. The layout is represented as an attention bias and complemented with contextualized visual information, while the core of our model is a pretrained encoder-decoder Transformer. Our novel approach achieves state-of-the-art results in extracting information from documents and answering questions which demand layout understanding (DocVQA, CORD, SROIE). At the same time, we simplify the process by employing an end-to-end model."
    },
    {
        title: "Contract discovery: Dataset and a few-shot semantic retrieval challenge with competitive baselines",
        authors: "\u0141 Borchmann, D Wi\u015Bniewski, A Gretkowski, I Kosmala, D Jurkiewicz, G Pa\u0142ka",
        citation: "Findings of the Association for Computational Linguistics: EMNLP 2020",
        year: "2020",
        citations: 0,
        link: "https://aclanthology.org/2020.findings-emnlp.380/",
        doi: "10.18653/v1/2020.findings-emnlp.380",
        dateISO: "2020-11-16",
        abstract: "We propose a new shared task of semantic retrieval from legal texts, in which a so-called contract discovery is to be performed \u2013 where legal clauses are extracted from documents, given a few examples of similar clauses from other legal acts. The task differs substantially from conventional NLI and shared tasks on legal information extraction (e.g., one has to identify text span instead of a single document, page, or paragraph). The specification of the proposed task is followed by an evaluation of multiple solutions within the unified framework proposed for this branch of methods. It is shown that state-of-the-art pretrained encoders fail to provide satisfactory results on the task proposed. In contrast, Language Model-based solutions perform better, especially when unsupervised fine-tuning is applied. Besides the ablation studies, we addressed questions regarding detection accuracy for relevant text fragments depending on the number of examples available. In addition to the dataset and reference results, LMs specialized in the legal domain were made publicly available."
    }
];
/**
 * Create HTML for a publication item
 * @param {Object} publication - Publication data
 * @returns {string} - HTML string for publication item
 */ function $8cdddf034d4a8d49$var$formatPublicationDate(publication) {
    if (!publication.dateISO) return publication.date || '';
    try {
        const lang = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039)?.language || 'en';
        const formatter = new Intl.DateTimeFormat(lang, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
        return formatter.format(new Date(publication.dateISO));
    } catch (e) {
        return publication.date || '';
    }
}
function $8cdddf034d4a8d49$var$createPublicationCard(publication) {
    const hasAbstract = publication.abstract && publication.abstract.trim() !== '';
    return `
    <div class="publication-item">
      <h4 class="publication-title">
        <a href="${publication.link}" target="_blank" rel="noopener noreferrer">${publication.title}</a>
      </h4>
      <div class="publication-meta">
        <div class="publication-line pub-authors">\u{2022} ${(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t('publications.labels.authors')} ${publication.authors}</div>
        <div class="publication-line pub-venue">\u{2022} ${(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t('publications.labels.venue')} ${publication.citation}</div>
        ${publication.doi ? `<div class="publication-line pub-doi">\u{2022} ${(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t('publications.labels.doi')} <a href=\"https://doi.org/${publication.doi}\" target=\"_blank\" rel=\"noopener noreferrer\">${publication.doi}</a></div>` : `<div class="publication-line pub-doi">\u{2022} ${(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t('publications.labels.url')} <a href=\"${publication.link}\" target=\"_blank\" rel=\"noopener noreferrer\">${publication.link}</a></div>`}
        <div class="publication-line pub-date">\u{2022} ${(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t('publications.labels.date')} ${$8cdddf034d4a8d49$var$formatPublicationDate(publication)}</div>
      </div>
      ${hasAbstract ? `<div class="publication-abstract-container">
          <button class="abstract-toggle" aria-expanded="false">${(0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t('publications.labels.showAbstract')}</button>
          <div class="publication-abstract" hidden>${publication.abstract}</div>
         </div>` : ''}
    </div>
  `;
}
/**
 * Create HTML for year section
 * @param {string} year - Year
 * @param {Array} yearPublications - Publications for that year
 * @returns {string} - HTML string for year section
 */ function $8cdddf034d4a8d49$var$createYearSection(year, yearPublications) {
    // Sort publications by dateISO (most recent first)
    const sortedYearPublications = [
        ...yearPublications
    ].sort((a, b)=>{
        if (a.dateISO && b.dateISO) return new Date(b.dateISO) - new Date(a.dateISO);
        return 0;
    });
    const publicationsHTML = sortedYearPublications.map((pub)=>$8cdddf034d4a8d49$var$createPublicationCard(pub)).join('');
    return `
    <div class="publications-year">
      <h3 class="year-heading">${year}</h3>
      <div class="year-publications">
        ${publicationsHTML}
      </div>
    </div>
  `;
}
/**
 * Setup abstract toggle buttons
 */ function $8cdddf034d4a8d49$var$setupAbstractToggles() {
    const toggleButtons = document.querySelectorAll('.abstract-toggle');
    toggleButtons.forEach((button)=>{
        button.addEventListener('click', ()=>{
            const abstractElement = button.nextElementSibling;
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            // Toggle the abstract visibility
            if (isExpanded) {
                abstractElement.setAttribute('hidden', '');
                button.setAttribute('aria-expanded', 'false');
                button.textContent = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t('publications.labels.showAbstract');
            } else {
                abstractElement.removeAttribute('hidden');
                button.setAttribute('aria-expanded', 'true');
                button.textContent = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t('publications.labels.hideAbstract');
            }
        });
    });
}
function $8cdddf034d4a8d49$export$69d10055ff4c9395() {
    const publicationsContainer = document.querySelector('.publications');
    if (!publicationsContainer) return;
    // Group publications by year
    const publicationsByYear = {};
    $8cdddf034d4a8d49$var$publications.forEach((pub)=>{
        if (!publicationsByYear[pub.year]) publicationsByYear[pub.year] = [];
        publicationsByYear[pub.year].push(pub);
    });
    // Get years and sort them in descending order
    const years = Object.keys(publicationsByYear).sort((a, b)=>b - a);
    // Generate HTML for all years
    const publicationsHTML = years.map((year)=>$8cdddf034d4a8d49$var$createYearSection(year, publicationsByYear[year])).join('');
    // Insert the HTML into the container
    publicationsContainer.innerHTML = publicationsHTML;
    // Setup toggle buttons
    $8cdddf034d4a8d49$var$setupAbstractToggles();
}
// Re-render publications on language change to localize dates
let $8cdddf034d4a8d49$var$publicationsLanguageListenerAttached = false;
if (!$8cdddf034d4a8d49$var$publicationsLanguageListenerAttached && typeof (0, $673ff3dfc4a496de$export$2e2bcd8739ae039) !== 'undefined' && (0, $673ff3dfc4a496de$export$2e2bcd8739ae039)?.on) {
    (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).on('languageChanged', ()=>{
        $8cdddf034d4a8d49$export$69d10055ff4c9395();
    });
    $8cdddf034d4a8d49$var$publicationsLanguageListenerAttached = true;
}


/**
 * Handles scroll animations for sections
 */ // Function to check if an element is in viewport
const $3f763f07b7f268f2$var$isElementInViewport = (el, offset = 100)=>{
    const rect = el.getBoundingClientRect();
    return rect.top <= (window.innerHeight || document.documentElement.clientHeight) - offset && rect.bottom >= 0;
};
function $3f763f07b7f268f2$export$4ae6feb6159b4594() {
    const sections = document.querySelectorAll('.section');
    const header = document.querySelector('.header');
    // Initial check for sections in viewport
    $3f763f07b7f268f2$var$checkSections(sections);
    // Throttle scroll/resize with requestAnimationFrame
    let scrollPending = false;
    window.addEventListener('scroll', ()=>{
        if (!scrollPending) {
            scrollPending = true;
            requestAnimationFrame(()=>{
                $3f763f07b7f268f2$var$checkSections(sections);
                $3f763f07b7f268f2$var$handleHeaderScroll(header);
                scrollPending = false;
            });
        }
    });
    let resizePending = false;
    window.addEventListener('resize', ()=>{
        if (!resizePending) {
            resizePending = true;
            requestAnimationFrame(()=>{
                $3f763f07b7f268f2$var$checkSections(sections);
                resizePending = false;
            });
        }
    });
    // Initial header state check
    $3f763f07b7f268f2$var$handleHeaderScroll(header);
    // Add parallax effect to sections
    $3f763f07b7f268f2$var$initParallaxEffects();
    // Set staggered transition delays (must run after publications are rendered)
    document.querySelectorAll('.timeline-item').forEach((item, index)=>{
        item.style.transitionDelay = `${index * 0.05}s`;
    });
    document.querySelectorAll('.publication-item').forEach((item, index)=>{
        item.style.transitionDelay = `${index * 0.05}s`;
    });
    document.querySelectorAll('.course').forEach((item, index)=>{
        item.style.transitionDelay = `${index * 0.05}s`;
    });
}
/**
 * Check if sections are in viewport and add 'visible' class
 * @param {NodeList} sections - The sections to check
 */ function $3f763f07b7f268f2$var$checkSections(sections) {
    sections.forEach((section)=>{
        const sectionTop = section.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        // If section is in viewport (with offset)
        if (sectionTop < windowHeight * 0.85) {
            section.classList.add('visible');
            // Animate children with staggered delay (skip already-animated)
            const animatableElements = section.querySelectorAll('.timeline-item, .course, .publication-item');
            animatableElements.forEach((el, index)=>{
                if (el.classList.contains('animate')) return;
                setTimeout(()=>{
                    el.classList.add('animate');
                    el.style.opacity = '1';
                    el.style.transform = 'translateY(0)';
                }, 100 * index);
            });
        }
    });
}
/**
 * Handle header scroll effects
 * @param {HTMLElement} header - The header element
 */ function $3f763f07b7f268f2$var$handleHeaderScroll(header) {
    if (!header) return;
    if (window.scrollY > 100) header.classList.add('scrolled');
    else header.classList.remove('scrolled');
}
/**
 * Initialize parallax effects on supported elements
 */ function $3f763f07b7f268f2$var$initParallaxEffects() {
    // Add a subtle parallax effect to hero image
    const heroImage = document.querySelector('.hero-image');
    const hero = document.querySelector('.hero');
    if (heroImage) {
        let mousePending = false;
        window.addEventListener('mousemove', (e)=>{
            if (mousePending) return;
            if (hero && !$3f763f07b7f268f2$var$isElementInViewport(hero, 0)) return;
            mousePending = true;
            requestAnimationFrame(()=>{
                const x = e.clientX / window.innerWidth;
                const y = e.clientY / window.innerHeight;
                heroImage.style.transform = `translate(${x * 10 - 5}px, ${y * 10 - 5}px)`;
                mousePending = false;
            });
        });
    }
    // Add tilt effect to specialty tags
    const specialtyTags = document.querySelectorAll('.specialty-tag');
    specialtyTags.forEach((tag)=>{
        tag.addEventListener('mousemove', (e)=>{
            const rect = tag.getBoundingClientRect();
            const x = (e.clientX - rect.left) / rect.width - 0.5;
            const y = (e.clientY - rect.top) / rect.height - 0.5;
            tag.style.transform = `perspective(300px) rotateX(${y * -5}deg) rotateY(${x * 5}deg) translateY(-3px)`;
        });
        tag.addEventListener('mouseleave', ()=>{
            tag.style.transform = '';
        });
    });
    // Add hover effect to section titles
    const sectionTitles = document.querySelectorAll('.section-title');
    sectionTitles.forEach((title)=>{
        title.addEventListener('mouseenter', ()=>{
            title.style.backgroundSize = '100% 100%';
        });
        title.addEventListener('mouseleave', ()=>{
            title.style.backgroundSize = '0% 100%';
        });
    });
}



// Education data - single source of truth
const $1ed7450bb13b69e6$export$6e4408f1372a0887 = {
    edu1: {
        degreeEn: "PhD in Computer Science",
        degreePl: "Doktor Informatyki",
        institutionEn: "Adam Mickiewicz University",
        institutionPl: "Uniwersytet im. Adama Mickiewicza w Poznaniu",
        thesisTitleEn: "Named entity recognition and information extraction from various documents",
        thesisTitlePl: "Rozpoznawanie jednostek nazwanych i ekstrakcja informacji z dokument\xf3w r\xf3\u017Cnego typu",
        supervisor: "prof. UAM dr hab. Tomasz G\xf3recki",
        defenseDate: "January 14, 2025",
        defenseDatePl: "14 stycznia 2025",
        abstractEn: "The thesis presents a novel application of named entity recognition and information extraction methods during the processing of documents of various types. The thesis consists of four scientific articles that have been published and presented at conferences of international scope. Chapter 1 describes the research problem, motivation and results obtained, as well as the structure and scope of the thesis. It also includes an overview and a brief summary of the included articles. Each description is preceded by information about the authors, the venue and type of presentation, and the contribution of the thesis author. Chapters 2 and 3 present research work related to the application of named entity recognition methods, which served as part of the solution to problems defined in competitions held at international conferences. Chapter 2 includes a description of the translation system developed as part of the WMT 2022 conference. Chapter 3 presents new models for lemmatization of named entities that were used in the solution of the competition organized as part of the Slavic NLP 2023 workshop. Chapters 4 and 5 focus on articles presenting neural network models developed as part of participation in the Industrial PhD program. Chapter 4 describes the TILT model created as part of the work on extracting information from documents with a two-dimensional structure (text and vision layer). Chapter 5 presents the STable model, which is an evolution of the TILT model and is used to extract tabular data. At the end of the thesis, the appendices include three certificates received from the organizers of the ICDAR 2021, WMT 2022 and Slavic NLP 2023 conferences, as well as the first pages of two patents obtained related to the TILT and STable models. Lastly, declarations of the contributions of the co-authors of each article presented in the thesis are included.",
        abstractPl: "Rozprawa doktorska prezentuje nowatorskie wykorzystanie metod rozpoznawania jednostek nazwanych i ekstrakcji informacji podczas przetwarzania dokument\xf3w r\xf3\u017Cnego typu. Praca sk\u0142ada si\u0119 z czterech artyku\u0142\xf3w naukowych, kt\xf3re zosta\u0142y opublikowane i zaprezentowane na konferencjach o zasi\u0119gu mi\u0119dzynarodowym. Rozdzia\u0142 1 opisuje problem badawczy, motywacj\u0119 i uzyskane efekty, a tak\u017Ce struktur\u0119 i zakres rozprawy. Zawiera r\xf3wnie\u017C przegl\u0105d oraz kr\xf3tkie podsumowanie za\u0142\u0105czonych artyku\u0142\xf3w. Ka\u017Cdy opis poprzedzony jest informacj\u0105 o autorach, miejscu i typie prezentacji oraz o wk\u0142adzie autora rozprawy. Rozdzia\u0142y 2 i 3 przedstawiaj\u0105 prace badawcze zwi\u0105zane z wykorzystaniem metod rozpoznawania jednostek nazwanych, kt\xf3re pos\u0142u\u017Cy\u0142y jako cz\u0119\u015B\u0107 rozwi\u0105zania problem\xf3w zdefiniowanych w konkursach organizowanych w ramach mi\u0119dzynarodowych konferencji. Rozdzia\u0142 2 zawiera opis systemu t\u0142umaczenia powsta\u0142ego w ramach konferencji WMT 2022. W rozdziale 3 zaprezentowano nowe modele lematyzacji jednostek nazwanych, kt\xf3re zosta\u0142y zastosowane w rozwi\u0105zaniu konkursu organizowanego w ramach warsztatu Slavic NLP 2023. Rozdzia\u0142y 4 i 5 skupiaj\u0105 si\u0119 na artyku\u0142ach prezentuj\u0105cych modele sieci neuronowych powsta\u0142e w ramach prac wdro\u017Ceniowych. Rozdzia\u0142 4 opisuje model TILT powsta\u0142y w ramach prac nad ekstrakcj\u0105 informacji z dokument\xf3w o dwuwymiarowej strukturze (warstwa tekstowa i wizyjna). W rozdziale 5 przedstawiono model STable b\u0119d\u0105cy rozwini\u0119ciem modelu TILT i s\u0142u\u017C\u0105cy do ekstrakcji danych tabelarycznych. Na ko\u0144cu pracy znajduj\u0105 si\u0119 za\u0142\u0105czniki, w kt\xf3rych zawarte s\u0105 trzy certyfikaty otrzymane od organizator\xf3w konferencji ICDAR 2021, WMT 2022 i Slavic NLP 2023, a tak\u017Ce pierwsze strony dw\xf3ch uzyskanych patent\xf3w zwi\u0105zanych z modelami TILT i STable. Jako ostatnie zamieszczone zosta\u0142y deklaracje o wk\u0142adzie wsp\xf3\u0142autor\xf3w ka\u017Cdego z artyku\u0142\xf3w przedstawionego w rozprawie."
    },
    edu2: {
        degreeEn: "Master's in Computer Science",
        degreePl: "Magister Informatyki",
        institutionEn: "Adam Mickiewicz University",
        institutionPl: "Uniwersytet im. Adama Mickiewicza w Poznaniu",
        thesisTitleEn: "Query expansion using language models",
        thesisTitlePl: "Rozszerzanie zapyta\u0144 przy u\u017Cyciu modeli j\u0119zyka",
        supervisor: "prof. UAM dr hab. Filip Grali\u0144ski",
        defenseDate: "June 30, 2020",
        defenseDatePl: "30 czerwca 2020",
        abstractEn: "This thesis presents thesaurus-based query expansion, query expansion using word embeddings, the Rocchio algorithm-based query expansion and query expansion using sentence similarities as examples of query reformulation for information retrieval systems. Implementation of the query expansion system using the aforementioned methods was also discussed. Finally, the system evaluation was presented and its results were analyzed.",
        abstractPl: "W pracy, jako przyk\u0142ady metod rozszerzania zapyta\u0144 dla system\xf3w wyszukiwania informacji, zosta\u0142y zaprezentowane: metoda s\u0142ownikowa, metoda wykorzystuj\u0105ca statyczne zanurzenia s\u0142\xf3w, metoda Rocchio oraz metoda wykorzystuj\u0105ca semantyczne podobie\u0144stwa fraz. Om\xf3wiona r\xf3wnie\u017C zosta\u0142a implementacja systemu rozszerzania zapyta\u0144 wykorzystuj\u0105ca wymienione metody. Na koniec przedstawiona zosta\u0142a ewaluacja systemu, a tak\u017Ce przeanalizowane zosta\u0142y jej wyniki."
    },
    edu3: {
        degreeEn: "Bachelor's in Computer Science",
        degreePl: "In\u017Cynier Informatyki",
        institutionEn: "Adam Mickiewicz University",
        institutionPl: "Uniwersytet im. Adama Mickiewicza w Poznaniu",
        thesisTitleEn: "Conference Management System - application for simplifying the process of creating and managing conferences",
        thesisTitlePl: "System Obs\u0142ugi Konferencji - Aplikacja wspomagaj\u0105ca tworzenie i uczestniczenie w konferencjach",
        supervisor: "prof. UAM dr hab. Krzysztof Dyczkowski",
        defenseDate: "February 13, 2019",
        defenseDatePl: "13 lutego 2019",
        abstractEn: "The purpose of this thesis is to present process of creating and implementing backend and frontend of web applications. This topic has been presented on the example of \"Conference Management System\" -- tool which has been created to simplify the process of creating and managing conferences. Thesis focuses on creating server-side application using CakePHP as well as using Vue.js framework with iView -- an UI Toolkit providing ready-to-use set of common components -- to create client-side application. Thesis contains some examples on how these frameworks have been used to create such applications.",
        abstractPl: 'Celem niniejszej pracy jest zaprezentowanie procesu budowania i implementacji backendu i frontendu dla aplikacji webowej. Temat ten zosta\u0142 om\xf3wiony na przyk\u0142adzie "Systemu obs\u0142ugi konferencji" - narz\u0119dzia u\u0142atwiaj\u0105cego stworzenie i zarz\u0105dzanie organizowan\u0105 konferencj\u0105. W pracy przedstawiono tworzenie aplikacji serwerowych w technologii CakePHP, a tak\u017Ce om\xf3wiono wykorzystanie frameworka Vue.js i iView w budowaniu aplikacji webowej. W pracy zawarte zosta\u0142y r\xf3wnie\u017C fragmenty kodu wy\u017Cej wspomnianych aplikacji.'
    },
    eduMathMaster: {
        degreeEn: "Master's in Mathematics",
        degreePl: "Magister Matematyki",
        institutionEn: "Adam Mickiewicz University",
        institutionPl: "Uniwersytet im. Adama Mickiewicza w Poznaniu",
        thesisTitleEn: "Computability concept formalizations",
        thesisTitlePl: "Formalizacje poj\u0119cia obliczalno\u015Bci",
        supervisor: "prof. UAM dr hab. Izabela Bondecka-Krzykowska",
        defenseDate: "July 9, 2019",
        defenseDatePl: "9 lipca 2019",
        abstractEn: "This thesis presents the recursive functions defined by Kurt Godel, single-tape Turing machines and lambda calculus without Alonzo Church's type theory as examples of formalizations of the concepts of computability theory. Operation of addition and the succesor function were presented in these three types of formalizations.Proof was also provided that these three formalizations are equivalent. Finally, the Church-Turing thesis was discussed.",
        abstractPl: "W pracy, jako przyk\u0142ady formalizacji poj\u0119cia obliczalno\u015Bci, przedstawiono funkcje rekurencyjne zdefiniowane przez Kurta Godla, jednota\u015Bmowe maszyny Alana Turinga i rachunek lambda bez typ\xf3w Alonzo Churcha. W tych trzech formalizacjach zaprezentowana zosta\u0142a operacja dodawania i funkcja nast\u0119pnika. Przytoczono tak\u017Ce dowody, \u017Ce te trzy formalizacje s\u0105 r\xf3wnowa\u017Cne. Na koniec om\xf3wiono tez\u0119 Churcha-Turinga."
    },
    eduMathBachelor: {
        degreeEn: "Bachelor's in Mathematics",
        degreePl: "Licencjat Matematyki",
        institutionEn: "Adam Mickiewicz University",
        institutionPl: "Uniwersytet im. Adama Mickiewicza w Poznaniu",
        thesisTitleEn: "\u0141ukasiewicz logic as an example of many valued logic",
        thesisTitlePl: "Logika \u0141ukasiewicza jako przyk\u0142ad logiki wielowarto\u015Bciowej",
        supervisor: "prof. UAM dr hab. Izabela Bondecka-Krzykowska",
        defenseDate: "July 3, 2017",
        defenseDatePl: "3 lipca 2017",
        abstractEn: "In this thesis, three-valued logic, created by Jan \u0141ukasiewicz, has been used as an example of many-valued logic system. Besides truth and false - two well known values from classical logic - \u0141ukasiewicz created a third, middle value that represents future, random events. This value is described as possibility or non-determination. This thesis presents the axioms of \u0141ukasiewicz logic system and discusses the problem of checking tautologies of formulas, based on three-valued logic system.",
        abstractPl: "W pracy, jako przyk\u0142ad logiki wielowarto\u015Bciowej, zosta\u0142a przedstawiona logika tr\xf3jwarto\u015Bciowa stworzona przez Jana \u0141ukasiewicza. Obok prawdy i fa\u0142szu - dw\xf3ch warto\u015Bci znanych z logiki klasycznej - \u0141ukasiewicz wprowadzi\u0142 trzeci\u0105, po\u015Bredni\u0105 warto\u015B\u0107 reprezentuj\u0105c\u0105 zdarzenia przysz\u0142e przypadkowe, kt\xf3r\u0105 interpretuje si\u0119 jako mo\u017Cliwo\u015B\u0107 lub niezdeterminowanie. W pracy om\xf3wiono badanie tautologiczno\u015Bci formu\u0142 na gruncie logiki tr\xf3jwarto\u015Bciowej, a tak\u017Ce przedstawiono system aksjomatyczny rachunku \u0141ukasiewicza."
    }
};


function $a6e7795d93ca0f79$export$a923c3e6bc69e238() {
    const educationItems = document.querySelectorAll('.timeline-item');
    educationItems.forEach((item)=>{
        // Check if this is an education item (has university logo)
        const universityLogo = item.querySelector('.university-logo');
        if (!universityLogo) return;
        // Find the education meta section
        const educationMeta = item.querySelector('.education-meta');
        if (!educationMeta) return;
        // Try to identify which education item this is based on any i18n key in the item
        const allI18nElements = item.querySelectorAll('[data-i18n]');
        let eduKey = null;
        for (const element of allI18nElements){
            const i18nKey = element.getAttribute('data-i18n');
            if (i18nKey && i18nKey.includes('experience.edu')) {
                // Extract education item key (e.g., 'edu1', 'edu2', etc.)
                const keyParts = i18nKey.split('.');
                if (keyParts.length >= 2) {
                    const possibleKey = keyParts[1];
                    if ((0, $1ed7450bb13b69e6$export$6e4408f1372a0887)[possibleKey]) {
                        eduKey = possibleKey;
                        break;
                    }
                }
            }
        }
        if (!eduKey) return;
        // Get abstract data
        const currentLang = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039)?.language || 'en';
        const abstractText = currentLang === 'pl' ? (0, $1ed7450bb13b69e6$export$6e4408f1372a0887)[eduKey].abstractPl : (0, $1ed7450bb13b69e6$export$6e4408f1372a0887)[eduKey].abstractEn;
        // Only add abstract functionality if abstract exists
        if (!abstractText || abstractText.trim() === '') return;
        // Create abstract container
        const abstractContainer = document.createElement('div');
        abstractContainer.className = 'education-abstract-container';
        // Create abstract toggle button (same style as publications)
        const abstractButton = document.createElement('button');
        abstractButton.className = 'abstract-toggle';
        abstractButton.setAttribute('aria-expanded', 'false');
        abstractButton.setAttribute('data-education-key', eduKey);
        abstractButton.textContent = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t('experience.labels.showAbstract');
        // Create abstract content div (same style as publications)
        const abstractContent = document.createElement('div');
        abstractContent.className = 'publication-abstract';
        abstractContent.setAttribute('hidden', '');
        abstractContent.setAttribute('data-education-key', eduKey);
        abstractContent.textContent = abstractText;
        // Add click event listener (same logic as publications)
        abstractButton.addEventListener('click', function() {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
                abstractContent.setAttribute('hidden', '');
                this.setAttribute('aria-expanded', 'false');
                this.textContent = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t('experience.labels.showAbstract');
            } else {
                abstractContent.removeAttribute('hidden');
                this.setAttribute('aria-expanded', 'true');
                this.textContent = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t('experience.labels.hideAbstract');
            }
        });
        // Append button and content to container
        abstractContainer.appendChild(abstractButton);
        abstractContainer.appendChild(abstractContent);
        // Insert container after the education meta
        educationMeta.parentNode.insertBefore(abstractContainer, educationMeta.nextSibling);
    });
}
function $a6e7795d93ca0f79$export$c8db1c076efd4a32() {
    const abstractButtons = document.querySelectorAll('.abstract-toggle[data-education-key]');
    const abstractContents = document.querySelectorAll('.publication-abstract[data-education-key]');
    const currentLang = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039)?.language || 'en';
    // Update button texts
    abstractButtons.forEach((button)=>{
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        if (isExpanded) button.textContent = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t('experience.labels.hideAbstract');
        else button.textContent = (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).t('experience.labels.showAbstract');
    });
    // Update abstract content
    abstractContents.forEach((abstractContent)=>{
        const eduKey = abstractContent.getAttribute('data-education-key');
        if (!eduKey || !(0, $1ed7450bb13b69e6$export$6e4408f1372a0887)[eduKey]) return;
        const abstractText = currentLang === 'pl' ? (0, $1ed7450bb13b69e6$export$6e4408f1372a0887)[eduKey].abstractPl : (0, $1ed7450bb13b69e6$export$6e4408f1372a0887)[eduKey].abstractEn;
        if (abstractText && abstractText.trim() !== '') abstractContent.textContent = abstractText;
    });
}
// Setup language change listener
let $a6e7795d93ca0f79$var$educationLanguageListenerAttached = false;
if (!$a6e7795d93ca0f79$var$educationLanguageListenerAttached && typeof (0, $673ff3dfc4a496de$export$2e2bcd8739ae039) !== 'undefined' && (0, $673ff3dfc4a496de$export$2e2bcd8739ae039)?.on) {
    (0, $673ff3dfc4a496de$export$2e2bcd8739ae039).on('languageChanged', ()=>{
        $a6e7795d93ca0f79$export$c8db1c076efd4a32();
    });
    $a6e7795d93ca0f79$var$educationLanguageListenerAttached = true;
}


// Set current year in the footer
document.getElementById('year').textContent = new Date().getFullYear();
// Initialize all modules
document.addEventListener('DOMContentLoaded', ()=>{
    (0, $9616fb7cd8a8c9e6$export$7b7f71765f51ec79)();
    (0, $9e30b5b5de697b16$export$56c6447e87399d89)();
    (0, $8cdddf034d4a8d49$export$69d10055ff4c9395)();
    (0, $a6e7795d93ca0f79$export$a923c3e6bc69e238)();
    (0, $3f763f07b7f268f2$export$4ae6feb6159b4594)();
});


//# sourceMappingURL=gabi-website.c10f6a2d.js.map
